<div class="row" [ngClass]="{ 'modal-container popup-general modal-md percent_35': isModal}" *ngIf="formMail">

    <div class="modal-container-header col-12" *ngIf="isModal">
        <span>{{ "gestion_terceros.popup.enviarMail" | translate }}</span>

        <span class="k-icon k-i-close" (click)="closeModal(false)"></span>
    </div>

    <div class="modal-container-section col-12">
        <form [formGroup]="formMail">
            <div class="row text-size-small ">
                <div class="col-12 ">
                    <div class="form-group fila-input only_reading">
                        <label class="anchurax20 text-right">
                            {{ "labels.de" | translate }}:</label>
                        <input formControlName="mailDe" type="text" class="form-control inline anchurax70 " />
                    </div>
                </div>
                <div class="col-12 mt-1">
                    <div class="form-group fila-input">
                        <label class="anchurax20 text-right mr-1">
                            {{ "labels.para" | translate }}:</label>
                        <input (blur)="blurElement('mailPara')" placeholder="{{placeholdermailPara}}"
                            [ngClass]="{  'form-error': getValueControl('mailPara') }" formControlName="mailPara"
                            type="text" class="form-control inline anchurax70 " />
                    </div>
                </div>
                <div class="col-12 mt-1">
                    <div class="form-group fila-input">
                        <label class="anchurax20 text-right mr-1">
                            {{ "labels.asunto" | translate }}:</label>
                        <input (blur)="blurElement('Asunto')" placeholder="{{placeholderAsunto}}"
                            [ngClass]="{  'form-error': getValueControl('Asunto') }" formControlName="Asunto"
                            type="text" class="form-control inline anchurax70 " />
                    </div>
                </div>
                <div class="col-12 mt-1">
                    <div class="form-group fila-textarea">
                        <label class="text-right anchurax20 mr-1">
                            {{ "labels.textEmail" | translate }}:</label>
                        <!-- maxLength="160" -->
                        <textarea (blur)="blurElement('Description')" placeholder="{{placeholderDescription}}"
                            [ngClass]="{  'form-error': getValueControl('Description') }" formControlName="Description"
                            class="inline anchurax70 form-control noResize " kendoTextArea></textarea>
                        <!-- <p class="color_naranja text-size-small ml-1">
                            {{ contadorCaracteres }}/160</p> -->
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-end mt-2">
                <button type="button" [disabled]="!comprobarCampos()" (click)="closeModal(true)"
                    class="btn btn-secondary float-right">
                    {{ "labels.enviar" | translate }}
                    <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                </button>
            </div>

        </form>

    </div>

</div>
